import React from 'react'
import { Datagrid, TextField, BulkDeleteWithConfirmButton } from 'react-admin'
import KList from 'ui-shared/KWrappers/KList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'

const FacetList: React.FC = () => {
  return (
    <SectionWrapper title={'resources.facet.sectionName'}>
      <KList pagination={false} exporter={false}>
        <Datagrid
          rowClick="edit"
          bulkActionButtons={
            <BulkDeleteWithConfirmButton mutationMode="optimistic" />
          }
        >
          <LocalizedTextField
            source="description"
            label="form.fields.description"
          />
          <TextField source="category" label="form.fields.category" />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default FacetList
